import { required, optional, obj, array } from 'AppReact/schema';

const stats = {
    assigned: optional('integer'),
    completed: optional('integer'),
    callback: optional('integer'),
    completion_time: optional('number'),
    rating: optional('number'),
}

export default {
    id: required('integer'),
    activated_at: optional('jsDate'),
    active: required('boolean'),
    address: optional('string'),
    attachment: optional('string'),
    categories: array(obj({ id: required('integer'), name: required('string') })),
    category_ids: array('integer'),
    contact_name: optional('string'),
    deactivated_at: optional('jsDate'),
    email: required('string'),
    inserted_at: required('jsDate'),
    name: required('string'),
    phone: optional('string'),
    properties: array('string'),
    property_ids: array('integer'),
    attachment: optional('string'),
    vendor_url: optional('string'),
    stats: obj(stats)
}
